module.exports = __webpack_public_path__ + "img/workout-notebook_B095QG2453.ed506ac8.jpg";